export default __webpack_public_path__ + "static/photo-5-2699f24268dc90fc114a70d048c82833.jpg";